// extracted by mini-css-extract-plugin
export default {"app":"App_app__rqre7","menu_visible":"App_menu_visible__1T6a+"};